/** Block explorer address URLs (EVM same address across chains). */
const EXPLORER_BASE: Record<string, string> = {
  ethereum: 'https://etherscan.io/address/',
  sepolia: 'https://sepolia.etherscan.io/address/',
  bsc: 'https://bscscan.com/address/',
  base: 'https://basescan.org/address/',
  avax: 'https://snowtrace.io/address/',
  polygon: 'https://polygonscan.com/address/',
  arb: 'https://arbiscan.io/address/',
  op: 'https://optimistic.etherscan.io/address/',
  ripple: 'https://livenet.xrpl.org/accounts/',
};

const EXPLORER_TX_BASE: Record<string, string> = {
  ethereum: 'https://etherscan.io/tx/',
  sepolia: 'https://sepolia.etherscan.io/tx/',
  bsc: 'https://bscscan.com/tx/',
  base: 'https://basescan.org/tx/',
  avax: 'https://snowtrace.io/tx/',
  polygon: 'https://polygonscan.com/tx/',
  arb: 'https://arbiscan.io/tx/',
  op: 'https://optimistic.etherscan.io/tx/',
  ripple: 'https://livenet.xrpl.org/transactions/',
};

export const EXPLORER_CHAIN_KEYS = ['ethereum', 'sepolia', 'bsc', 'base', 'avax', 'polygon', 'arb', 'op'] as const;
export type ExplorerChainKey = (typeof EXPLORER_CHAIN_KEYS)[number];

export function explorerAddressUrl(chain: string, address: string): string | null {
  const base = EXPLORER_BASE[chain];
  if (!base) {
    return null;
  }
  const a = address.trim();
  if (!a) {
    return null;
  }
  return base + encodeURIComponent(a);
}

/** Token detail on the chain explorer: `/address/0x…` for contracts; native opens explorer home. */
export function explorerTokenUrl(chain: string, storedRef: string): string | null {
  const base = EXPLORER_BASE[chain];
  if (!base) {
    return null;
  }
  const ref = storedRef.trim().toLowerCase();
  if (ref === 'native' || ref === '') {
    try {
      return new URL(base).origin + '/';
    } catch {
      return null;
    }
  }
  if (!/^[0-9a-f]{40}$/.test(ref)) {
    return null;
  }
  return base + encodeURIComponent(`0x${ref}`);
}

export function explorerTxUrl(chain: string, txHash: string): string | null {
  const base = EXPLORER_TX_BASE[chain];
  if (!base) {
    return null;
  }
  const h = txHash.trim();
  if (!h) {
    return null;
  }
  return base + encodeURIComponent(h);
}
